import { jsxs as m, jsx as t } from "react/jsx-runtime";
import { useLanguage as p, useLocaleText as y, Group as _, Paragraph as s, Divider as h, sharedHandler as f } from "@ingeniorforeningen/figurine-core";
import { forwardRef as x } from "react";
import '../../../assets/AuthorByline.css';const v = "_group_1lg6a_2", N = "_author_1lg6a_6", b = "_divide_1lg6a_14", A = "_date_1lg6a_25", e = {
  group: v,
  author: N,
  divide: b,
  date: A
}, r = x((i, n) => {
  const { byline: a, date: o, noPrefix: l, ...c } = i, { language: d } = p(), u = y(), g = l ? a : `${u.by} ${a}`;
  return /* @__PURE__ */ m(_, { direction: "row", align: "center", spacing: "md", ref: n, className: e.group, ...c, children: [
    a && /* @__PURE__ */ t(
      s,
      {
        strong: !0,
        variant: "primary",
        align: "left",
        text: g,
        className: e.author
      }
    ),
    /* @__PURE__ */ t(h, { orientation: "vertical", size: "sm", className: e.divide }),
    o && /* @__PURE__ */ t(
      s,
      {
        align: "left",
        transform: "uppercase",
        className: e.date,
        text: `${o.toLocaleString(d, {
          day: "numeric",
          month: "long",
          year: "numeric"
        })}`
      }
    )
  ] });
});
r.displayName = "AuthorByline";
const B = f(r);
B.displayName = r.displayName;
export {
  e as S,
  r as _AuthorByline,
  B as default
};
